import { useEffect } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '@/lib/auth'

export function AuthGuard({ children }: { children: React.ReactNode }) {
  const whoami = useAuth((s) => s.whoami)
  const loading = useAuth((s) => s.loading)
  const initialized = useAuth((s) => s.initialized)
  const refresh = useAuth((s) => s.refresh)
  const location = useLocation()

  useEffect(() => {
    if (!initialized && !loading) {
      void refresh()
    }
  }, [initialized, loading, refresh])

  // Wait for the first whoami probe to land before deciding anything —
  // otherwise a page refresh would redirect to /login for a split second
  // before the session cookie has been exchanged for an auth state.
  if (!initialized || loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-muted-foreground">
        Loading…
      </div>
    )
  }

  if (!whoami) {
    return <Navigate to="/login" replace state={{ from: location }} />
  }

  return <>{children}</>
}
